import React, { createElement } from "react";
import { Nav, NavItem } from "reactstrap";
import { Icon, Home, Calendar, List, Users, File, PieChart, BarChart, Clipboard, CheckCircle } from "react-feather";
import { NavLink, useLocation, matchPath } from "react-router-dom";
import classnames from "classnames";

import { useTypedSelector } from "../../store/models/root.interface";

type NavMenuProps = {
  expanded?: boolean;
  showMarketing?: boolean;
}

const link = (
  label: string,
  path: string,
  icon: Icon,
  isChild: boolean = false,
  exact: boolean = false,) => (
  <NavLink
    className={classnames({
      "nav-link c-nav__link": true,
      "c-nav__link--child": isChild
    })}
    to={path}
    exact={exact}>
    {createElement(icon, { className: "c-nav__icon" })}
    <div className="c-nav__label">{label}</div>
  </NavLink>
);

const NavMenu: React.FC<NavMenuProps> = ({ expanded, showMarketing }) => {
  const location = useLocation();
  const subscriptionsState = useTypedSelector(state => state.subscriptions.items);
  const reportsState = useTypedSelector(state => state.reports.reports);
  const subscriptions = typeof subscriptionsState !== "string" ? subscriptionsState : [];
  const anyReports = !!reportsState?.length;
  return (
    <Nav vertical className="c-nav">
      {/* Home */}
      <NavItem className="c-nav__item">
        {link("Home", "/", Home, false, true)}
      </NavItem>
      {/* Events */}
      <NavItem
        className={classnames({
          "c-nav__item": true,
          "c-nav__item--open": location.pathname.startsWith("/events"),
        })}
      >
        {link("Events", "/events", Calendar)}
        {location.pathname.startsWith("/events") && (
          <Nav vertical className="c-nav">
            <NavItem className="c-nav__item">
              {link("Events List", "/events/list", List, true)}
            </NavItem>
            {!!matchPath(location.pathname, { path: "/events/:eventId/:ticketId/attendees" }) && (
              <NavItem className="c-nav__item">
                {link("Event Attendees", location.pathname, Users, true)}
              </NavItem>
            )}
            <NavItem className="c-nav__item">
              {link("Attendees", "/events/attendees", Users, true)}
            </NavItem>
          </Nav>
        )}
      </NavItem>
      {/* Marketing */}
      {!!showMarketing && (
        <NavItem
          className={classnames({
            "c-nav__item": true,
            "c-nav__item--open": location.pathname.startsWith("/marketing"),
          })}
        >
          {link("Marketing", "/marketing", Clipboard)}
          {location.pathname.startsWith("/marketing") && (
            <Nav vertical className="c-nav">
              <NavItem className="c-nav__item">
                {link("Activities", "/marketing/activities", List, true)}
              </NavItem>
              <NavItem className="c-nav__item">
                {link("Objectives", "/marketing/objectives", CheckCircle, true)}
              </NavItem>
            </Nav>
          )}
        </NavItem>
      )}
      {/* Reports */}
      {anyReports && (
        <NavItem
          className={classnames({
            "c-nav__item": true,
            "c-nav__item--open": location.pathname.startsWith("/reports"),
          })}
        >
          {link("Data Insights", "/reports", PieChart)}
          {location.pathname.startsWith("/reports") && (
            <Nav vertical className="c-nav">
              {reportsState?.map(item => (
                <NavItem key={item.reportId} className="c-nav__item">
                  {link(item.name, `/reports/${item.alias}`, BarChart, true)}
                </NavItem>
              ))}
            </Nav>
          )}
        </NavItem>
      )}
      {/* Documents */}
      {subscriptions?.map(item => (
        <NavItem key={item.id} className="c-nav__item">
          {link(item.name, `/data/${item.id}`, File)}
        </NavItem>
      ))}
    </Nav>
  );
}

export default NavMenu
